import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from '../SearchWidget.module.scss';
import {connect} from "react-redux";
import submitBtnImgPath from "../../../assets/media/submitIcon.svg";
import WindowEventWatcher from "../../Common/WindowEventWatcher";
import Field from "../../../tools/Field";
import {withTranslation} from "react-i18next";
import Popup from "../Common/Popup";
import {replaceSpecialChars} from "../../../tools/tools";

const ManageTripForm = ({lang, formRef, t}) => {

    const [popupOpen, setPopupOpen] = useState(false);
    const [fields, setFields] = useState({
        bookingCode: new Field('bookingCode', '', '', v => /^[A-Za-z0-9]{0,6}$/g.test(v), v => /^[A-Za-z0-9]{6}$/g.test(v)),
        lastName: new Field('lastName', '', '', v => /^.*$/g.test(v), v => /^.+$/g.test(v)),
    });

    const handleSubmit = e => {
        const validation = Field.validateAllFields(fields);
        setFields({...validation.fields});
        if (validation.isAllValid) {
            formRef.current.submit();
        }
    };

    const onChange = (field, e) => {
        const value = replaceSpecialChars(e.target.value);

        if (field.validate(value, true).getIsInvalid()) {
            setTimeout(() => {
                field.validate();
                setFields({...fields, [field.key]: {...field}});
            }, 1000);
        } else {
            field.setValue(value);
        }

        setFields({...fields, [field.key]: {...field}});
    };

    const onBlurHandler = (field, e) => {
        field.validate();
        setFields({...fields, [field.key]: {...field}});
    };

    const keyDownHandler = e => {
        const code = e.code ? e.code : e.key;

        switch (code) {
            case 'NumpadEnter':
            case 'Enter':
                handleSubmit();
                break;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    const submitClasses = [styles.manageTripFormSubmitBtnContainer];
    if (!(fields.bookingCode.getIsValid() && fields.lastName.getIsValid())) submitClasses.push(styles.manageTripFormSubmitBtnDisabled);

    const formAction = `https://booking.azoresairlines.pt/rzoweb/app/pnr?action=pnrSearch&lastname=${fields.lastName.getValue()}&pnr=${fields.bookingCode.getValue()}&search=search&lang=${lang.substring(0,2)}`;

    return (
        <div className={styles.manageTripFormExternalContainer}>
            <div className={styles.manageTripFormContainer}>
                <WindowEventWatcher handlerFn={keyDownHandler} eventName={'keydown'}/>
                <div className={styles.genericFormMessageLeft}>
                    {t('This option allows you to select')}<br/>
                    {t('your seat onboard and to book')}<br/>
                    {t('additional services to the flight')}.
                </div>
                <form method='POST' action={formAction} ref={formRef}>
                    <input type='hidden' name='form_id' value='manage-trip-form'/>
                    <input type='hidden' name='form_build_id' value={window.manageTripFormId || ''}/>
                    <div className={styles.manageTripFormInputContainer}>
                        <label htmlFor={'booking-code-field'}>
                            {t('Booking code')}
                        </label>
                        <div className={styles.manageTripFormInputContainerInner}>
                            <input
                                autoCorrect='none'
                                autoCapitalize='none'
                                spellCheck='none'
                                id={'booking-code-field'}
                                name='booking-code'
                                size={15}
                                maxLength={60}
                                type='text'
                                placeholder={t('e.g. X2C1V3')}
                                className={fields.bookingCode.getIsInvalid() ? styles.genericFormInvalidInput : ''}
                                value={fields.bookingCode.getValue()}
                                onChange={e => onChange(fields.bookingCode, e)}
                                onBlur={e => onBlurHandler(fields.bookingCode, e)}
                                required
                                aria-required/>
                            <i className={[styles.genericInfoIcon, 'icon-sata-info-icon'].join(' ')}
                               title={t('What is a booking code?')}
                               onClick={() => setPopupOpen(true)}>
                                <Popup show={popupOpen} closeHandler={e => {e.stopPropagation();setPopupOpen(false);}}>
                                    <span style={{fontFamily: 'NeoSansMedium', width: '300px', fontSize: '0.85em'}}>{t('What is a booking code?')}</span>
                                    <span style={{fontSize: '0.85em'}}>{t('It is an alphanumeric code with 6 characters')}.</span>
                                    <span style={{fontSize: '0.85em'}}>{t("You can find it in your electronic ticket in 'Booking reference'")}.</span>
                                </Popup>
                            </i>
                        </div>
                    </div>
                    <div className={styles.manageTripFormInputContainer}>
                        <label htmlFor={'last-name-field'}>
                            {t('Last name')}
                        </label>
                        <div className={styles.manageTripFormInputContainerInner}>
                            <input
                                autoCorrect='none'
                                autoCapitalize='none'
                                autoComplete='off'
                                spellCheck='none'
                                id={'last-name-field'}
                                name='last-name'
                                size={60}
                                maxLength={128}
                                className={fields.lastName.getIsInvalid() ? styles.genericFormInvalidInput : ''}
                                value={fields.lastName.getValue()}
                                onChange={e => onChange(fields.lastName, e)}
                                onBlur={e => onBlurHandler(fields.lastName, e)}
                                type='text'
                                placeholder={t('Last name')}
                                required
                                aria-required/>
                            &nbsp;
                            <div onClick={handleSubmit}
                                 className={submitClasses.join(' ')}
                                 tabIndex={0}>
                                <img src={submitBtnImgPath} alt={'manage trip submit btn'}/>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
            <div className={styles.manageTripFormBottomArea} id={'search-widget-book-flight-opts'}/>
        </div>

    );
};

ManageTripForm.propTypes = {
    formRef: PropTypes.any,
    lang: PropTypes.string,
    t: PropTypes.func,
};

ManageTripForm.defaultProps = {
    formRef: React.createRef(),
    lang: 'en',
    t: s => s,
};

export default withTranslation()(connect(state => ({lang: state.common.lang}))(ManageTripForm));

